import { Chunk } from '@/components/AskMeAnything/types';

const BASE_URL = process.env.VITE_API_BASE;

export const streamResponse = async (
  prompt: string,
  threadId: string,
  onChunk: (chunk: Chunk) => void,
  signal?: AbortSignal
): Promise<void> => {
  const token = localStorage.getItem('idToken');

  const response = await fetch(`${BASE_URL}/agent/askMeAnything/chat`, {
    method: 'POST',
    body: JSON.stringify({ message: prompt, threadId }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    signal
  });

  if (!response.ok || !response.body) {
    throw new Error('Stream failed or no response body available.');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // Process complete SSE messages
    const events = buffer.split('\n\n');
    buffer = events.pop() || ''; // keep incomplete for next round

    for (const event of events) {
      const lines = event.split('\n');

      for (const line of lines) {
        if (line.startsWith('data:')) {
          const jsonStr = line.replace(/^data:\s*/, '');

          try {
            const parsed: Chunk = JSON.parse(jsonStr);
            onChunk(parsed);
          } catch (err) {
            console.warn('Failed to parse SSE chunk:', jsonStr, err);
          }
        }
      }
    }
  }

  reader.releaseLock();
};
